<template>
	<svg
		:width="size"
		:height="size"
		viewBox="0 0 20 20"
		xmlns="http://www.w3.org/2000/svg"
		fill="none"
		role="img"
		:aria-hidden="ariaHidden"
	>
		<path
			d="M9.58333 17.9167H5.41667C4.97464 17.9167 4.55072 17.7411 4.23816 17.4285C3.92559 17.116 3.75 16.692 3.75 16.25V2.91667C3.75 2.47465 3.92559 2.05072 4.23816 1.73816C4.55072 1.4256 4.97464 1.25001 5.41667 1.25001H12.0833C12.3474 1.24936 12.609 1.30101 12.853 1.40199C13.097 1.50297 13.3186 1.65127 13.505 1.83834L16.495 4.82834C16.6821 5.01473 16.8304 5.23633 16.9313 5.48033C17.0323 5.72434 17.084 5.98593 17.0833 6.25001V10.4167"
			:stroke="computedStroke"
			:stroke-width="strokeWidth"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
		<path
			d="M12.0833 1.25V5.41667C12.0833 5.63768 12.1711 5.84964 12.3274 6.00592C12.4837 6.1622 12.6956 6.25 12.9167 6.25H17.0833"
			:stroke="computedStroke"
			:stroke-width="strokeWidth"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
		<path
			d="M12.9167 13.75L17.0833 17.9167"
			:stroke="computedStroke"
			:stroke-width="strokeWidth"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
		<path
			d="M17.0833 13.75L12.9167 17.9167"
			:stroke="computedStroke"
			:stroke-width="strokeWidth"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
	</svg>
</template>

<script>
export default {
	name: 'IconFileTimes',
	props: {
		size: {
			type: [Number, String],
			default: 20
		},
		color: {
			type: String,
			default: 'currentColor'
		},
		filled: {
			type: Boolean,
			default: true
		},
		strokeWidth: {
			type: [Number, String],
			default: 1.65
		},
		ariaHidden: {
			type: Boolean,
			default: true
		}
	},
	computed: {
		computedFill() {
			return this.filled ? this.color : 'none'
		},
		computedStroke() {
			return this.color
		}
	}
}
</script>
